/* ODAKI — entradas de sección y cruce lento de fotos.
   Cada contenedor [data-odk-reveal] entra una vez, con sus hijos
   [data-odk-item] escalonados en orden de lectura. Sin JavaScript, o con
   movimiento reducido, todo queda visible desde el primer cuadro. */
(() => {
  "use strict";

  const root = document.documentElement;
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function indexItems(scope) {
    scope.querySelectorAll("[data-odk-reveal]").forEach((group) => {
      if (group.dataset.odkIndexed) return;
      group.dataset.odkIndexed = "1";
      let i = 0;
      group.querySelectorAll(":scope > [data-odk-item]").forEach((item) => {
        item.style.setProperty("--odk-i", String(i++));
      });
    });
  }

  function reveal(scope) {
    indexItems(scope);
    const groups = Array.from(scope.querySelectorAll("[data-odk-reveal]:not(.is-in)"));
    if (!groups.length) return;

    if (reduce || !("IntersectionObserver" in window)) {
      groups.forEach((g) => g.classList.add("is-in"));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-in");
          io.unobserve(entry.target);
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.01 }
    );

    groups.forEach((g) => io.observe(g));
  }

  /* Cruce lento: [data-odk-crossfade] alterna sus hijos [data-odk-frame]
     cada ~5.5 s con un fundido de 1.6 s. Se pausa con la pestaña oculta.
     [data-odk-crossfade-delay] retrasa el arranque, para que varios cuadros
     de un mismo collage no cambien todos en el mismo instante. */
  function crossfade(scope) {
    scope.querySelectorAll("[data-odk-crossfade]").forEach((box) => {
      if (box.dataset.odkCrossfadeBound) return;
      box.dataset.odkCrossfadeBound = "1";
      const frames = Array.from(box.querySelectorAll("[data-odk-frame]"));
      if (frames.length < 2 || reduce) return;
      const delay = Number(box.dataset.odkCrossfadeDelay) || 0;
      let current = 0;
      let timer = null;
      let pending = null;
      const step = () => {
        current = (current + 1) % frames.length;
        frames.forEach((frame, i) => {
          const shown = i === current;
          frame.classList.toggle("is-current", shown);
          if (shown) {
            frame.removeAttribute("aria-hidden");
            frame.removeAttribute("tabindex");
          } else {
            frame.setAttribute("aria-hidden", "true");
            frame.setAttribute("tabindex", "-1");
          }
        });
      };
      const start = () => {
        if (timer || pending) return;
        pending = window.setTimeout(() => {
          pending = null;
          timer = window.setInterval(step, 5600);
        }, delay);
      };
      const stop = () => {
        window.clearTimeout(pending);
        window.clearInterval(timer);
        pending = null;
        timer = null;
      };
      document.addEventListener("visibilitychange", () => (document.hidden ? stop() : start()));
      start();
    });
  }

  function init(scope) {
    reveal(scope);
    crossfade(scope);
  }

  root.classList.add("odk-js");
  window.odkMotion = true;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(document));
  } else {
    init(document);
  }

  /* Editor de temas: volver a enlazar al recargar una sección */
  document.addEventListener("shopify:section:load", (e) => init(e.target));

  /* Seguridad: si algo no entró en 2.5 s, se muestra igual */
  window.setTimeout(() => {
    document.querySelectorAll("[data-odk-reveal]:not(.is-in)").forEach((g) => {
      const r = g.getBoundingClientRect();
      if (r.top < window.innerHeight) g.classList.add("is-in");
    });
  }, 2500);
})();
